import gql from 'graphql-tag';

export default gql`
    mutation AuthRegister($request: AuthRegisterInputType!) {
        auth {
            register(request: $request) {
                __typename
                ... on AuthRegisterSuccess {
                    token
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
            }
        }
    }
`;
